import React from 'react';
import { Gift, Zap, Users, Smartphone, Laptop } from 'lucide-react';

export default function BetaBenefitsSection() {
  return (
    <section className="py-24 md:py-32 px-4 sm:px-6 lg:px-8 bg-[#050505]" data-testid="beta-benefits-section">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-bold text-center text-white mb-4 tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
          Join the Beta Programme
        </h2>
        <p className="text-center text-zinc-400 mb-12 text-lg leading-relaxed">
          Help us build the UK's best media reseller platform—earn rewards and connect with fellow flippers
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="bg-[#0A0A0A] border border-[#FFD700]/30 rounded-2xl p-6 hover:border-[#FFD700]/60 transition-colors shadow-lg">
            <Gift className="w-12 h-12 text-[#FFD700] mb-4" />
            <h3 className="text-lg font-bold text-white mb-2">3 Years Free (Worth £540)</h3>
            <p className="text-zinc-400 text-sm leading-relaxed">
              Beta testers get 3 years free membership at our £15/month Part-Time tier. That's £540 in value.
            </p>
          </div>

          <div className="bg-[#0A0A0A] border border-[#00D26A]/30 rounded-2xl p-6 hover:border-[#00D26A]/60 transition-colors shadow-lg">
            <div className="flex gap-2 mb-4">
              <Smartphone className="w-10 h-10 text-[#00D26A]" />
              <Laptop className="w-10 h-10 text-[#00D26A]" />
            </div>
            <h3 className="text-lg font-bold text-white mb-2">Exclusive Equipment Upgrade Programme</h3>
            <p className="text-zinc-400 text-sm leading-relaxed">
              Planned partnership programme — use your Flipping Friends earnings to work towards a new smartphone or laptop. Full details revealed to beta testers at launch.
            </p>
          </div>

          <div className="bg-[#0A0A0A] border border-[#00D26A]/30 rounded-2xl p-6 hover:border-[#00D26A]/60 transition-colors shadow-lg">
            <Users className="w-12 h-12 text-[#00D26A] mb-4" />
            <h3 className="text-lg font-bold text-white mb-2">Join Our Community</h3>
            <p className="text-zinc-400 text-sm leading-relaxed">
              Connect with fellow flippers, share strategies, and learn from experienced resellers. Flipping doesn't have to be lonely anymore.
            </p>
          </div>

          <div className="bg-[#0A0A0A] border border-[#FFD700]/30 rounded-2xl p-6 hover:border-[#FFD700]/60 transition-colors shadow-lg">
            <Zap className="w-12 h-12 text-[#FFD700] mb-4" />
            <h3 className="text-lg font-bold text-white mb-2">Early Access</h3>
            <p className="text-zinc-400 text-sm leading-relaxed">
              Be the first to use Flipping Friends before the public launch. Get a competitive edge.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
